import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da579bf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row left" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "Code",
  class: "form-check-label me-2"
}, "Code", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "Type",
  class: "form-check-label me-2"
}, "Type", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "Dates",
  class: "form-check-label me-2"
}, "Start date", -1))
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "Dates",
  class: "form-check-label me-2"
}, "End date", -1))
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "MaxNumberOfUsers",
  class: "form-check-label me-2"
}, "Max number of users", -1))
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "NumberOfUsesPerUser",
  class: "form-check-label me-2"
}, "Number of uses per user", -1))
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "NumberOfUsesDebitOrCreditCard",
  class: "form-check-label me-2"
}, "Number of uses per debit or credit card", -1))
const _hoisted_19 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "FreeShipping",
  class: "form-check-label me-2"
}, "Free shipping", -1))
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "FreeShippingCourier",
  class: "form-check-label me-2"
}, "Free shipping by Courier", -1))
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-check-label me-2" }, "Currencies")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_27 = { class: "row left middle" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "form-check-label me-2" }
const _hoisted_31 = { class: "col-md-1" }
const _hoisted_32 = {
  key: 0,
  class: "form-check-label me-2"
}
const _hoisted_33 = {
  key: 1,
  class: "form-check-label me-2"
}
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = { class: "form-check-label me-2" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_41 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "error" }, "Validation Errors")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_kdate = _resolveComponent("kdate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            id: "Code",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.Code) = $event)),
            type: "text",
            class: "form-control",
            disabled: !!_ctx.$route.params.id
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.model.Code]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("select", {
            id: "Type",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.Type) = $event)),
            class: "form-select",
            "aria-label": "Select Type"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                key: item.Id,
                value: item.Id
              }, _toDisplayString(item.Name), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.model.Type]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_kdate, {
            id: "Dates",
            format: 'dd/MM/yyyy',
            "default-value": new Date(),
            value: _ctx.model.Start,
            onChange: _ctx.updateStart
          }, null, 8, ["default-value", "value", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_kdate, {
            id: "Dates",
            format: 'dd/MM/yyyy',
            "default-value": new Date(),
            value: _ctx.model.End,
            onChange: _ctx.updateEnd
          }, null, 8, ["default-value", "value", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _withDirectives(_createElementVNode("input", {
            id: "MaxNumberOfUsers",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.MaxNumberOfUsers) = $event)),
            type: "number",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.MaxNumberOfUsers]
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _withDirectives(_createElementVNode("input", {
            id: "NumberOfUsesPerUser",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.NumberOfUsesPerUser) = $event)),
            type: "number",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.NumberOfUsesPerUser]
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("input", {
            id: "NumberOfUsesDebitOrCreditCard",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.NumberOfUsesDebitOrCreditCard) = $event)),
            type: "number",
            class: "form-control"
          }, null, 512), [
            [_vModelText, _ctx.model.NumberOfUsesDebitOrCreditCard]
          ])
        ]),
        (_ctx.model.Type != 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("input", {
                id: "FreeShipping",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.FreeShipping) = $event)),
                type: "checkbox",
                class: "form-check-input"
              }, null, 512), [
                [_vModelCheckbox, _ctx.model.FreeShipping]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            id: "FreeShippingCourier",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.FreeShippingCourier) = $event)),
            type: "checkbox",
            class: "form-check-input"
          }, null, 512), [
            [_vModelCheckbox, _ctx.model.FreeShippingCourier]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "btn m-2 btn-primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.save()))
          }, " Save ")
        ])
      ]),
      (_ctx.model.Type != 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _hoisted_26,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.Branches, (branch, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "mb-3"
              }, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("label", _hoisted_30, _toDisplayString(branch.BranchCode), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    (_ctx.model.Type == 1)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_32, " % "))
                      : (_openBlock(), _createElementBlock("label", _hoisted_33, _toDisplayString(branch.Symbol), 1))
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((branch.Amount) = $event),
                      type: "number",
                      class: "form-control"
                    }, null, 8, _hoisted_35), [
                      [_vModelText, branch.Amount]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("label", _hoisted_37, "Limit (" + _toDisplayString(branch.Symbol) + ")", 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((branch.OrderValueLimit) = $event),
                      type: "number",
                      class: "form-control"
                    }, null, 8, _hoisted_39), [
                      [_vModelText, branch.OrderValueLimit]
                    ])
                  ])
                ]),
                _hoisted_40
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.errors.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
            _hoisted_42,
            _hoisted_43,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (e, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "mb-3 error"
              }, _toDisplayString(e), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}